import React, { Fragment } from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "../../records/components/AttributesForm"

const ConfigureFieldButton = props => {
    const onChange = newOptions => {
        let changes = {}
        Object.keys(newOptions).forEach(key => (changes["options." + key] = newOptions[key]))
        props.onChange(changes)
    }
    const optionsPerType = {
        lookup: [
            {
                type: "lookup",
                label: "Link to",
                api_name: "lookup_target",
                options: { lookup_target: "object" },
            },
        ],
        dropdown: [
            {
                type: "key_value",
                label: "Options (label, value)",
                api_name: "options",
            },
        ],
    }
    return (
        <ButtonModal
            button={({ open }) => (
                <Button icon="cog" color="clear" padding="small" margin="none" onClick={open}>
                    Configure
                </Button>
            )}
            header={() => `Configure`}
            footerClassName={css`
                justify-content: flex-end;
            `}
            footer={({ close, state }) => [
                <Button
                    key="create"
                    sideMargin="xsmall"
                    color="success"
                    onClick={() => {
                        onChange(state)
                        close()
                    }}
                >
                    Save
                </Button>,
                <Button key="cancel" sideMargin="xsmall" onClick={close}>
                    Close
                </Button>,
            ]}
        >
            {({ setState }) => (
                <AttributesForm
                    onChange={setState}
                    fields={optionsPerType[props.type]}
                    defaultState={props.data}
                />
            )}
        </ButtonModal>
    )
}
export default ConfigureFieldButton



// WEBPACK FOOTER //
// ./src/features/studio/components/ConfigureFieldButton.js